module.exports = __webpack_public_path__ + "./images/plus.svg?674a838077bfc670c264c0d82352b42b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus.svg
// module id = 10
// module chunks = 0